<script>
	export default {
		props: ['value', 'title', 'id', 'options', 'color', 'disabled' , 'multiSelect'],

		data() {
			return {
				content: this.value,
			}
		},

		watch: {
			value: {
				handler(newData, oldData) {
					if (newData !== oldData) {
						this.content = newData
					}
				},
				immediate: true,
			},
		},

		computed: {
			cssVars() {
				return {
					'--company-color': this.color,
				}
			},
		},

		methods: {
			handleInput(option) {
			  	const opValue = option.value || option;
				if(this.multiSelect) {
                  /**
				   * @toggle value
                   */
                  if (this.isButtonSelected(opValue)) {
                    this.content = this.content.filter(item => item !== opValue);
				  } else {
                    if (!this.content) {
                      this.content = [];
					}
                    this.content.push(opValue);
				  }
                  this.$emit('input', this.content);
				  return;
				}

				this.$emit('input', opValue); // in case `option` is not an object
			},
			isButtonSelected(value) {
				if(this.multiSelect) {
					return (this.content || []).includes(value)
				}else {
					return this.content === value
				}
			}
		},
	}
</script>

<template>
	<div :style="cssVars">
		<p class="text-sm font-medium mb-12px">{{ title }}</p>

		<div class="flex items-stretch flex-flow">
			<div
				v-for="option in options"
				:key="option.value"
				class="option flex items-center bg-white relative w-auto py-7px overflow-hidden rounded-20px border border-solid"
				:class="{'border-chrome': !isButtonSelected(option.value), 'border-company-color': isButtonSelected(option.value)}"
			>
				<!-- Input -->
				<input
					:value="option.value"
					:type="multiSelect ? 'checkbox' : 'radio'"
					:name="id"
					:id="id + '_' + option.label"
					class="form-input"
					@change="($ev) => handleInput(option)"
					:disabled="disabled"
					:checked="isButtonSelected(option.value)"
				/>
				<!-- Label -->
				<label
					:for="id + '_' + option.label"
					class="form-label text-sm font-medium text-onyx text-center cursor-pointer"
				>
					<p v-if="option.short_hand" class="flex items-center">
						<span class="font-bold">{{ option.short_hand }}</span>
						<span
							class="text-10 ml-8px inline-block text-left"
							:class="{
								'max-w-116': option.short_hand === 'X', // 🤷🏼‍♂️ no other choice
								'max-w-145': option.short_hand !== 'X',
							}"
						>
							{{ option.label }}
						</span>
					</p>
					<p v-else>{{ option.label }}</p>
				</label>
			</div>
			<!-- Hack to get all selected multiSelect or selected disabled elements on form submit -->
			<input v-if="multiSelect | disabled" type="hidden" :value="content" :name="id">
		</div>
	</div>
</template>

<style scoped>
	.two_options .option {
		@apply px-24px;
	}
	.multi_options .option {
		@apply px-16px;
	}
	.form-input {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;

		/* Ensures element doesn't consume space */
		height: 0;
		width: 0;
	}

	.form-input::before {
		content: '';
		cursor: pointer;
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.form-input:checked::before {
		background-color: var(--company-color);
	}

	.form-input:checked ~ .form-label {
		color: #ffffff !important;
	}

	.form-label {
		z-index: 1;
	}

	.flex-flow {
		flex-flow: row wrap;
		row-gap: 8px;
		column-gap: 8px;
	}
</style>
